<form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" class="space-y-4">
  <div class="max-w-7xl mx-auto p-6 grid grid-cols-1 lg:grid-cols-3 gap-8">
    <!-- Left Section -->
    <div class="lg:col-span-2 space-y-6">
      <h2 class="text-2xl font-semibold">Checkout Info</h2>

      <!-- Contact Info -->
      <div class="bg-white shadow rounded-lg p-6 space-y-4">
        <h3 class="text-lg font-semibold">Contact Info</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input formControlName="name" type="text" placeholder="Full Name" class="w-full border p-2 rounded" />
          <!--<input type="text" placeholder="Full Name" class="border rounded p-2 w-full" value="Muhammad Masud Sikder">-->
          <input formControlName="phone" type="text" placeholder="Phone Number" class="w-full border p-2 rounded" />
          <!--<input type="text" placeholder="Phone" class="border rounded p-2 w-full" value="01731808906">-->
          <input formControlName="email" type="email" placeholder="Email" class="w-full border p-2 rounded" />
          <!--<input type="email" placeholder="Email" class="border rounded p-2 w-full md:col-span-2" value="muhammadmasudsikder@gmail.com">-->
        </div>
      </div>

      <!-- Shipping Info -->
      <div class="bg-white shadow rounded-lg p-6 space-y-4">
        <h3 class="text-lg font-semibold">Shipping Info</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <textarea formControlName="address" placeholder="Shipping Address" class="w-full border p-2 rounded"></textarea>
          <input formControlName="city" type="text" placeholder="City" class="w-full border p-2 rounded" />
          <input formControlName="altPhone" type="text" placeholder="Alternative Phone" class="w-full border p-2 rounded" />
          <input formControlName="notes" type="text" placeholder="Notes" class="w-full border p-2 rounded" />
        </div>
      </div>

      <!-- Payment Summary -->
      <div class="bg-white shadow rounded-lg p-6">
        <p class="text-lg">Your total payable amount is</p>
        <p class="text-green-600 text-3xl font-bold">৳{{ total + shippingCharge }}</p>
        <h4 class="font-semibold mt-4">Breakdown</h4>
        <table class="w-full text-left mt-2 border">
          <thead>
            <tr class="border-b">
              <th class="p-2">Purpose</th>
              <th class="p-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b">
              <td class="p-2">Total</td>
              <td class="p-2">৳{{ total }}</td>
            </tr>
            <tr>
              <td class="p-2">Shipping</td>
              <td class="p-2">৳{{ shippingCharge }}</td>
            </tr>
          </tbody>
        </table>
        <p class="mt-2 text-sm text-green-700">You will get the delivery <span class="font-semibold">within 2-3 Days</span> after confirmation.</p>
      </div>

      <!-- Payment Options -->
      <div class="payment-method">
        <div class="bg-white shadow rounded-lg p-6 space-y-4">
          <h3 class="text-lg font-semibold">Payment Options</h3>

          <div class="flex items-center space-x-4">

            <!-- Cash on Delivery -->
            <label class="flex items-center space-x-2 border rounded p-2 cursor-pointer">
              <input type="radio" formControlName="paymentMethod" name="paymentMethod" value="cod">
              <span>Cash on Delivery</span>
            </label>

            <!-- Visa / Mastercard -->
            <!--<label class="flex items-center space-x-2 border rounded p-2 cursor-pointer">
    <input type="radio" formControlName="paymentMethod" name="paymentMethod" value="visaMastercard">
    <span>Pay with Stripe</span>
    <button (click)="pay('Stripe')" class="btn">Pay with Stripe</button>
    <button (click)="pay('PayPal')" class="btn">Pay with PayPal</button>
  </label>-->
            <!-- Visa / Mastercard -->
            <!-- Stripe -->
            <label class="flex items-center gap-3 border rounded p-3 cursor-pointer hover:bg-gray-50">
              <input type="radio"
                     formControlName="paymentMethod"
                     value="Stripe"
                     class="mt-1" />
              <!--<span class="flex-1 font-medium">Visa / Mastercard (Stripe)</span>-->

              <button type="button"
                      class="px-4 py-2 bg-indigo-600 text-white rounded disabled:opacity-50"
                      [disabled]="checkoutForm.value.paymentMethod !== 'Stripe'">
                Pay with Stripe
              </button>
            </label>

            <!-- PayPal -->
            <!--<label class="flex items-center gap-3 border rounded p-3 cursor-pointer hover:bg-gray-50">
              <input type="radio"
                     formControlName="paymentMethod"
                     value="PayPal"
                     class="mt-1" />-->
              <!--<span class="flex-1 font-medium">Visa / Mastercard (PayPal)</span>-->

              <!--<button type="button"
                      class="px-4 py-2 bg-yellow-500 text-black rounded disabled:opacity-50"
                      [disabled]="checkoutForm.value.paymentMethod !== 'PayPal'">
                Pay with PayPal
              </button>
            </label>-->

            <!-- SSLCommerz -->
            <label class="flex items-center gap-3 border rounded p-3 cursor-pointer hover:bg-gray-50">
              <input type="radio"
                     formControlName="paymentMethod"
                     value="SSLCommerz"
                     class="mt-1" />
              <!--<span class="flex-1 font-medium">Visa / Mastercard (PayPal)</span>-->

              <button type="button"
                      class="px-4 py-2 bg-yellow-500 text-black rounded disabled:opacity-50"
                      [disabled]="checkoutForm.value.paymentMethod !== 'SSLCommerz'">
                Pay with SSLCommerz
              </button>
            </label>

            <!-- bKash -->
            <label class="flex items-center space-x-2 border rounded p-2 cursor-pointer">
              <input type="radio" formControlName="paymentMethod" name="paymentMethod" value="bKash">
              <span>bKash (10% Cashback)</span>
            </label>

          </div>

          <p class="text-sm text-gray-600">Note: bKash 10% Cashback up to BDT 150</p>
        </div>
      </div>

        <!-- Coupon -->
        <!--<div class="bg-white shadow rounded-lg p-6">
      <h3 class="text-lg font-semibold">Got any Coupon Code?</h3>
      <div class="flex space-x-2 mt-2">
        <input type="text" placeholder="Enter Coupon Code Here" class="border rounded p-2 w-full">
        <button class="bg-blue-500 text-white px-4 py-2 rounded">Add Coupon</button>
      </div>
    </div>-->
        <!-- Terms & Confirm -->
        <div class="bg-white shadow rounded-lg p-6 space-y-4">
          <label class="flex items-center space-x-2">
            <input type="checkbox" checked>
            <span>I agree to <a href="#" class="text-blue-500">Terms & Conditions</a>, <a href="#" class="text-blue-500">Refund Policy</a> and <a href="#" class="text-blue-500">Privacy Policy</a> of Wearistyle.</span>
          </label>
          <button class="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded w-full">{{ getButtonText() }}</button>
        </div>
      </div>

      <!-- Right Section -->
      <div class="bg-white shadow rounded-lg p-6">
        <h3 class="text-lg font-semibold">Cart Overview</h3>
        <div *ngFor="let item of cartItems" class="mt-4 space-y-4">
          <!-- Product -->
          <div class="flex items-center justify-between border-b pb-2">
            <div class="flex items-center space-x-2">
              <img src="{{ environment.apiBaseUrl+item.product.imagePath }}" alt="{{ item.product.name }}" class="w-16 h-16 object-cover rounded">
              <!--<img [src]="product.imagePath" alt="{{ product.name }}" class="h-16 w-16 object-cover mx-auto" />-->
            <div>
              <!--<input type="hidden" [(ngModel)]="item.product.vendorId" name="vendorId" />-->
              <p class="text-sm">{{ item.product.name }} <span class="font-semibold">Size: {{ item.size }}</span></p>
              <p class="text-sm">{{ item.quantity }} × <span class="line-through text-gray-400">৳{{item.product.price}}</span> <span class="font-semibold">৳{{item.product.price}}</span></p>
            </div>
            </div>
          </div>
        </div>
        <div class="mt-4 border-t pt-4 text-right space-y-1">
          <p>Total: <span class="font-semibold">৳{{ total }}</span></p>
          <p>Shipping: <span class="font-semibold">৳{{ shippingCharge }}</span></p>
          <p class="text-green-600 font-bold">Payable: ৳{{ total + shippingCharge }}</p>
        </div>
      </div>
    </div>
</form>
